import styled from "styled-components";
import PageHeader from "../PageHeader/PageHeader";

const Wrapper = styled.div<{ $fill?: boolean; $maxWidth?: number }>`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  ${(props) =>
    props.$maxWidth !== undefined
      ? `max-width: ${props.$maxWidth}px;`
      : ""}
  ${(props) =>
    props.$fill
      ? `
    height: calc(100vh - var(--shell-top, 0px) - 2 * var(--page-pad-y, 24px));
    min-height: 520px;
  `
      : "padding-bottom: 32px;"}
`;

const Toolbar = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px 16px;
`;

const Body = styled.div<{ $fill?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 0;
  ${(props) => (props.$fill ? "flex: 1; min-height: 0;" : "")}
`;

// Standard frame for a backoffice page: header, optional toolbar, content.
const Page: React.FC<{
  title: React.ReactNode;
  description?: React.ReactNode;
  badge?: React.ReactNode;
  actions?: React.ReactNode;
  // Row of filters / status shown under the header
  toolbar?: React.ReactNode;
  maxWidth?: number;
  // Lock the page to the viewport height (maps, chat); content scrolls inside
  fill?: boolean;
  children?: React.ReactNode;
}> = ({
  title,
  description,
  badge,
  actions,
  toolbar,
  maxWidth,
  fill,
  children,
}) => {
  return (
    <Wrapper $fill={fill} $maxWidth={maxWidth}>
      <PageHeader
        title={title}
        description={description}
        badge={badge}
        actions={actions}
      />
      {toolbar && <Toolbar>{toolbar}</Toolbar>}
      <Body $fill={fill}>{children}</Body>
    </Wrapper>
  );
};
export default Page;
